export default __webpack_public_path__ + "b5bf2064f669c0570785222fd08318e6.webp";